import BaseModel from './BaseModel'
import {makeObservable, observable} from 'mobx'

export default class MemberQuery extends BaseModel {
  constructor(store) {
    super(store);
    makeObservable(this, {
      page_number: observable,
      page_count: observable,
      count: observable,
      company_id: observable,
      company_user_id: observable,
      role_id: observable,
      name: observable,
      year_born: observable,
      forma_number: observable,
      include_archived: observable
    })
  }

  page_number = 1;
  page_count = 1;
  count = 0;
  company_id = 0;
  company_user_id = 0;
  role_id = null;
  name = '';
  year_born = '';
  forma_number = '';
  include_archived = false;
}